import React from "react";
import Navbar from "../../components/base/landing/navbar";
import FooterLanding from "../../components/base/landing/footer";
import FormDemo from "../../components/base/landing/form";
import WhatsApp from "../../components/base/whatsapp";
import BlogButton from "../../components/base/blog";



const BlogPage = () => {
    return (
      <>
        <Navbar />
        <FormDemo />
        <FooterLanding/>
        <BlogButton/>
        <WhatsApp/>
      </>
    );
  };
  
  export default BlogPage;